var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_603_350",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.0605469,
    width: 25.5,
    height: 25.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_603_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 22.373C5.47812 22.373 4.97786 22.165 4.56172 21.7488C4.14557 21.3327 3.9375 20.8324 3.9375 20.248V5.37305C3.9375 4.78867 4.14557 4.28841 4.56172 3.87227C4.97786 3.45612 5.47812 3.24805 6.0625 3.24805H20.9375C21.5219 3.24805 22.0221 3.45612 22.4383 3.87227C22.8544 4.28841 23.0625 4.78867 23.0625 5.37305V12.4918C22.726 12.3324 22.3807 12.1952 22.0266 12.0801C21.6724 11.965 21.3094 11.8809 20.9375 11.8277V5.37305H6.0625V20.248H12.4906C12.5437 20.6376 12.6279 21.0095 12.743 21.3637C12.8581 21.7178 12.9953 22.0543 13.1547 22.373H6.0625ZM6.0625 20.248V5.37305V11.8277V11.748V20.248ZM8.1875 18.123H12.5172C12.5703 17.7512 12.6544 17.3882 12.7695 17.034C12.8846 16.6798 13.013 16.3345 13.1547 15.998H8.1875V18.123ZM8.1875 13.873H14.6688C15.2354 13.3418 15.8685 12.8991 16.568 12.5449C17.2674 12.1908 18.0156 11.9517 18.8125 11.8277V11.748H8.1875V13.873ZM8.1875 9.62305H18.8125V7.49805H8.1875V9.62305ZM19.875 24.498C18.4052 24.498 17.1523 23.9801 16.1164 22.9441C15.0805 21.9082 14.5625 20.6553 14.5625 19.1855C14.5625 17.7158 15.0805 16.4629 16.1164 15.427C17.1523 14.391 18.4052 13.873 19.875 13.873C21.3448 13.873 22.5977 14.391 23.6336 15.427C24.6695 16.4629 25.1875 17.7158 25.1875 19.1855C25.1875 20.6553 24.6695 21.9082 23.6336 22.9441C22.5977 23.9801 21.3448 24.498 19.875 24.498ZM19.3438 22.373H20.4062V19.7168H23.0625V18.6543H20.4062V15.998H19.3438V18.6543H16.6875V19.7168H19.3438V22.373Z",
    fill: "#00A377"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNotes);
export default __webpack_public_path__ + "static/media/add_notes.242d7415ca970ef1151f62c994235f02.svg";
export { ForwardRef as ReactComponent };